import axios from "axios";
import { API_CONFIG, API_CONFIG_OMISIONES } from "../config/apiConfig";

// Create axios instance
const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    ...API_CONFIG.HEADERS,
    "x-api-key": API_CONFIG.X_API_KEY
  }
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      localStorage.removeItem("empresa_id");
      localStorage.removeItem("uid_empresa");
      window.location.href = "/authentication/split/login";
    }
    return Promise.reject(error);
  }
);

/*********************************************
********** Servicio Omisiones **********
**********************************************/

const apiClientOmisiones = axios.create({
  baseURL: API_CONFIG_OMISIONES.BASE_URL,
  timeout: API_CONFIG_OMISIONES.TIMEOUT,
  headers: {
    ...API_CONFIG_OMISIONES.HEADERS,
  }
});

// Request interceptor
apiClientOmisiones.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token_omisiones");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const ConsumoService = {
  getAuth: async (filtros) => {
    try {
      const response = await apiClientOmisiones.post(
        `/api/auth/login`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  getCompanyHistory: async (companyId, filtros) => {
    try {
      const response = await apiClientOmisiones.get(
        `/api/packages/company/${companyId}/history?${filtros}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  getNotificationConsumptions: async (filtros) => {
    try {//falta agregar el bearer
      const response = await apiClientOmisiones.get(
        `/api/notification-consumptions${filtros}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  getNotificationPackages: async (filtros) => {
    try {
      const response = await apiClientOmisiones.get(
        `/api/packages${filtros}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};
/*********************************************
********** Servicio Autorización **********
**********************************************/
// API methods
export const authService = { //autorización
  login: async (credentials) => {
    try {
      const response = await apiClient.post("/api/auth/Login", credentials);
      return response.data;
    } catch (error) {
      console.error("Error en la solicitud de inicio de sesión:", {
        message: error.message,
        config: error.config,
        response: error.response,
        request: error.request,
      });
      throw error;
    }
  }
};

export const VehiculosService = {
  getVehiculos: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/vehiculo/coleccion-vehiculos`
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getVehiculosByEmpresa: async (empresaUids) => {
    try {
      // ✅ OPTIMIZACIÓN: Si recibe un array, convertirlo a string separado por comas
      // Esto permite al backend filtrar múltiples empresas en una sola consulta
      // Ejemplo: ['EMP001', 'EMP002'] → 'EMP001,EMP002'
      const empresaParam = Array.isArray(empresaUids) ? empresaUids.join(',') : empresaUids;

      const response = await apiClientAlertas.get(
        `/catalogos/vehiculo/coleccion-vehiculos`,
        {
          params: { empresaUid: empresaParam }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error cargando vehículos por empresa:", error.response?.data || error);
      throw error;
    }
  },
  getVehiculosCamara: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/vehiculo/coleccion-vehiculos-con-camaras`
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
};

export const GeocercaService = {
  getGeocercas: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/geocerca/coleccion-geocercas`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};

export const ClienteService = {
  getClientes: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/cliente/coleccion-clientes`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};

export const ReferenciaService = {
  getReferencias: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/referencia/coleccion-referencias`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};

export const ChoferesService = {
  getChoferes: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/chofer/coleccion-choferes`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};

export const GruposService = {
  getGrupos: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/grupo/coleccion-grupos`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  getGruposByEmpresa: async (empresaUids) => {
    try {
      // ✅ OPTIMIZACIÓN: Si recibe un array, convertirlo a string separado por comas
      // Esto permite al backend filtrar múltiples empresas en una sola consulta
      // Ejemplo: ['EMP001', 'EMP002'] → 'EMP001,EMP002'
      const empresaParam = Array.isArray(empresaUids) ? empresaUids.join(',') : empresaUids;

      const response = await apiClientAlertas.get(
        `/catalogos/grupo/coleccion-grupos`,
        {
          params: { empresaUid: empresaParam }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error cargando grupos por empresa:", error.response?.data || error);
      throw error;
    }
  },
};

/*********************************************
********** Servicio Reporte Bitacora **********
**********************************************/
export const BitacoraService = {
  getBitacoras: async (filtros) => {
    try {
      const response = await apiClient.post(
        `/api/catalogos/bitacora/obtener-reporte-bitacora`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  getCategoriaBitacoras: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/bitacora/obtener-categoria-bitacora`, {  }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  getUsuarios: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/usuario/coleccion-usuarios`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
  addBitacora: async (data) => {
    try {
      const response = await apiClient.post("/api/catalogos/bitacora/agregar-reporte-bitacora", data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
};
/*********************************************
********** Servicio Reporte Punto Cercano **********
**********************************************/
export const PuntoCercanoService = {
  getPuntosCercanos: async (filtros) => {
    try {
      const response = await apiClient.post(
        `/api/reportes/puntocercano/obtener-reporte-punto-cercano`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
};
/*********************************************
********** Servicio Reporte Alertas **********
**********************************************/

export const AlertaService = {
  getTipoAlertaQuro: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/alerta/coleccion-tipo-alertas-quro`
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getTipoAlertaCamaraIA: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/alerta/coleccion-tipo-alertas-ia`
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getTipoAlertaOmisiones: async () => {
    try {
      const response = await apiClient.get(
        `/api/catalogos/alerta/coleccion-tipo-alertas-omisiones`
      );
      console.warn("Tipo de alertas de omisiones:", response.data);
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getAlertaReporteQuro: async (filtros) => {
    try {
      const filtrosActualizados = { ...filtros };

      const response = await apiClient.post(
        `/api/reportes/alerta/obtener-reporte-alertas-quro`,
        filtrosActualizados
      );

      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getAlertaReporteCamaraIA: async (filtros) => {
    try {
      const filtrosActualizados = { ...filtros };

      const response = await apiClient.post(
        `/api/reportes/alertsV2/obtener-reporte-alertas-ia-v2`,
        filtrosActualizados
      );

      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getAlertaReporteOmisiones: async (filtros) => {
    try {
      const response = await apiClient.post(
        `/api/reportes/alerta/obtener-reporte-alertas-omisiones`,
        filtros
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  }
};
/*********************************************
********** Servicio Reporte Recorridos **********
**********************************************/

export const ReporteRecorridoService = {
  getReporteRecorridos: async (filtros) => {
    try {
      const response = await apiClient.post(
        `/api/reportes/recorridos/obtener-reporte-de-recorridos-completo`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
  getTokenConexionQuro: async () => {
    try {
      const response = await apiClient.get(
        `/api/reportes/recorridos/obtener-token-temporal-en-quro`
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  }
};


/*********************************************
********** Nuevo Cliente Alertas API **********
**********************************************/
const apiClientAlertas = axios.create({
  baseURL: process.env.REACT_APP_ALERTS_API_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    ...API_CONFIG.HEADERS,
    "Content-Type": "application/json"
  }
});

// Request interceptor para API de alertas
apiClientAlertas.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor para API de alertas
apiClientAlertas.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      localStorage.removeItem("empresa_id");
      localStorage.removeItem("uid_empresa");
      window.location.href = "/authentication/split/login";
    }
    return Promise.reject(error);
  }
);

export const CamarasService = {
  getHistorialDeVisualizacion: async (filtros) => {
    try {
      // Usando el nuevo cliente apiClientAlertas en lugar de apiClient
      const response = await apiClientAlertas.post(
        `/alertsV2/obtener-historial-de-reproduccion-v2`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error.response?.data || error);
      // Lanzamos el error para que pueda ser manejado por el componente
      throw error;
    }
  },
};

/*********************************************
********** Servicio Empresas **********
**********************************************/
export const EmpresasService = {
  getEmpresas: async () => {
    try {
      const response = await apiClientAlertas.get('/empresas');
      return response.data;
    } catch (error) {
      console.error("Error cargando empresas:", error.response?.data || error);
      throw error;
    }
  },
};


// export const CamarasService = {
//   getHistorialDeVisualizacion: async (filtros) => {
//     try {
//       const response = await apiClient.post(// apiClient.post(
//         `/api/camaras/camara/obtener-historial-de-reproduccion`, filtros
//       );
//       return response.data;
//     } catch (error) {
//       console.error(error.response.data);
//     }
//   },
// };

/*********************************************
********** Servicio Reporte Tiempos **********
**********************************************/

export const UsabilityService = {
  getUsabilityData: async (filtros) => {
    try {
      const response = await apiClient.post(
        `/api/reportes/tiempos/obtener-reporte-de-tiempos`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
};

/***************
**** Servicio Reporte Estadias ****
****************/

export const ReporteEstadiaService = {
  getReporteEstadia: async (filtros) => {
    try {
      const response = await apiClient.post(
        '/api/reportes/estadia/obtener-reporte-de-estadias-organizado', filtros
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
};

/*********************************************
********** Servicio Reporte km ***************
**********************************************/

export const ReportKmService = {
  getListData: async (filtros) => {
    try {
      const response = await apiClient.post(
        `/api/reportes/recorridos/obtener-reporte-de-recorridos-km`, filtros
      );
      return response.data;
    } catch (error) {
      console.error(error.response.data);
    }
  },
};